// extracted by mini-css-extract-plugin
export default {"card":"member_card__bmqYp","price":"member_price__U2M6R","pix":"member_pix__YsAoS","pixLabel":"member_pixLabel__iUugx","help":"member_help__usqo2"};